import type { Starter } from '../Starter'

export const riskStarters: Starter[] = [
  {
    // Trigger artifact (audit-due) — compass-flagged per owner decision
    // 2026-06-11 (supersedes the plan's unflagged-trojan default).
    id: 'audit-readiness-check',
    name: 'Audit Readiness Check',
    description: 'Controls × evidence status',
    thumbnailUrl: '/assets/images/thumbnails/tb_kanban.svg',
    artifact: { kind: 'seed', seedId: 'audit-readiness-check', diagramType: 'flowchart' },
    job: ['assess-risk'],
    function: ['risk-compliance'],
    growsInto: 'compass',
    trigger: 'audit-due',
    collaborative: ['assign-owners', 'external-review'],
    requiredFlag: 'COMPASS_ENABLED',
    curatedBy: 'creately',
  },
  {
    id: 'risk-register',
    name: 'Risk Register',
    description: 'Likelihood × impact board',
    thumbnailUrl: '/assets/images/thumbnails/tb_kanban.svg',
    artifact: { kind: 'seed', seedId: 'risk-register', diagramType: 'flowchart' },
    job: ['assess-risk'],
    function: ['risk-compliance'],
    growsInto: 'compass',
    collaborative: ['assign-owners'],
    curatedBy: 'creately',
  },
  {
    id: 'vendor-risk-map',
    name: 'Vendor Risk Map',
    description: 'Vendors by criticality',
    thumbnailUrl: '/assets/images/thumbnails/tb_kanban.svg',
    artifact: { kind: 'seed', seedId: 'vendor-risk-map', diagramType: 'flowchart' },
    job: ['assess-risk'],
    function: ['risk-compliance'],
    growsInto: 'compass',
    collaborative: ['assign-owners'],
    curatedBy: 'creately',
  },
  {
    id: 'escalation-matrix',
    name: 'Escalation Matrix',
    description: 'Who to call, when',
    thumbnailUrl: 'https://svg.template.creately.com/is0k9x191',
    artifact: { kind: 'legacy', templateId: 'is0k9x191', legacyType: 'diagram/def/block.js#Block' },
    job: ['assess-risk'],
    function: ['risk-compliance'],
    growsInto: 'compass',
    collaborative: ['assign-owners'],
    curatedBy: 'creately',
  },
  {
    id: 'change-control',
    name: 'Change Control',
    description: 'Change approval flow',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    artifact: { kind: 'seed', seedId: 'change-control', diagramType: 'flowchart' },
    job: ['assess-risk'],
    function: ['risk-compliance'],
    growsInto: 'process',
    collaborative: ['assign-owners'],
    curatedBy: 'creately',
  },
  {
    id: 'control-process',
    name: 'Control Process',
    description: 'Control steps & checks',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    artifact: { kind: 'seed', seedId: 'control-process', diagramType: 'flowchart' },
    job: ['assess-risk'],
    function: ['risk-compliance'],
    growsInto: 'process',
    collaborative: ['assign-owners'],
    curatedBy: 'creately',
  },
  {
    id: 'access-review',
    name: 'Access Review',
    description: 'Entitlements & attestations',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    artifact: { kind: 'seed', seedId: 'access-review', diagramType: 'flowchart' },
    job: ['assess-risk', 'map-process'],
    function: ['risk-compliance', 'operations'],
    growsInto: 'process',
    collaborative: ['external-review'],
    curatedBy: 'creately',
  },
  {
    id: 'evidence-collection-flow',
    name: 'Evidence Collection',
    description: 'Request to audit response',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    artifact: { kind: 'seed', seedId: 'evidence-collection-flow', diagramType: 'flowchart' },
    job: ['assess-risk', 'map-process'],
    function: ['risk-compliance', 'operations'],
    growsInto: 'process',
    collaborative: ['external-review'],
    curatedBy: 'creately',
  },
  {
    id: 'policy-exception-flow',
    name: 'Policy Exception',
    description: 'Risk review & expiry',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    artifact: { kind: 'seed', seedId: 'policy-exception-flow', diagramType: 'flowchart' },
    job: ['assess-risk', 'map-process'],
    function: ['risk-compliance', 'operations'],
    growsInto: 'process',
    collaborative: ['assign-owners'],
    curatedBy: 'creately',
  },
  {
    id: 'incident-management',
    name: 'Incident Management',
    description: 'Detect, restore, review',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    artifact: { kind: 'seed', seedId: 'incident-management', diagramType: 'flowchart' },
    job: ['map-process', 'assess-risk'],
    function: ['operations', 'risk-compliance'],
    growsInto: 'process',
    trigger: 'incident',
    collaborative: ['share-view'],
    curatedBy: 'creately',
  },
  {
    id: 'service-request-fulfillment',
    name: 'Service Request',
    description: 'Catalog to fulfillment',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    artifact: { kind: 'seed', seedId: 'service-request-fulfillment', diagramType: 'flowchart' },
    job: ['map-process'],
    function: ['operations'],
    growsInto: 'process',
    collaborative: ['share-view'],
    curatedBy: 'creately',
  },
  {
    id: 'problem-management',
    name: 'Problem Management',
    description: 'Root cause & known errors',
    thumbnailUrl: '/assets/images/thumbnails/tb_flowchart.svg',
    artifact: { kind: 'seed', seedId: 'problem-management', diagramType: 'flowchart' },
    job: ['map-process', 'assess-risk'],
    function: ['operations', 'risk-compliance'],
    growsInto: 'process',
    collaborative: ['share-view'],
    curatedBy: 'creately',
  },
]
